import React, { useState, useEffect, useRef } from 'react';
import {Helmet} from "react-helmet";
import {Breadcrumb, BreadcrumbItem, Button, Row, Col, Alert} from "reactstrap";
import VisitsComponent from "../VisitsComponent";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { Link, withRouter } from 'react-router-dom';
import CameraAltIcon from "@material-ui/icons/CameraAlt";

function CarerDashboard(props) {
  const { getCarerVisits, getCarerVisitError, getCarerVisitSuccess, getCarerVisitLoader } = props;
  const prevErrorRef = useRef();
  const isMounted = useRef(false);
  const [carerVisits, setCarerVisits] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [filter, setFilter] = useState("today");


  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value;
    setFilter(selectedFilter);

    // Create payload based on selected filter
    let payload = { config: "pastDays", days: 0 }; // Default to today
    if (selectedFilter === "yesterday") {
      payload = { config: "pastDays", days: 1 };
    } else if (selectedFilter === "tomorrow") {
      payload = { config: "pastDays", days: -1 };
    } else if (selectedFilter === "all") {
      payload = { config: "all" };
    }
    getCarerVisits(payload);
  };


  const handleVisitClick = (data) => {
    // Build the query string with parameters
    const vid = data.id;
    const queryString = `?q=single&vid=${vid}`;

    // Navigate to the CallLogging route with query parameters
    props.history.push(`/ecm/call-logging/${queryString}`);
  };

  // Initial
  useEffect(() => {
    window.scrollTo(0, 0)
    setError(false)
    let payload = { config: "pastDays", days: 0 }
    // let payload = { config: 'all'}
    getCarerVisits(payload);
  }, [])

  // Success
  useEffect(() => {
    if (getCarerVisitSuccess) {
      if (getCarerVisitSuccess.length === 0) {
        setMessage("No visits assigned.");
        setError(true)
      }
      setMessage('');
      setError(false);
      setCarerVisits(getCarerVisitSuccess);
    }
  }, [getCarerVisitSuccess]);

  // Error
  useEffect(() => {
    if (!isMounted.current) {
      // Skip on initial mount
      isMounted.current = true;
      return;
    }
    if (
      getCarerVisitError !== prevErrorRef.current &&
      getCarerVisitError &&
      getCarerVisitError.includes("401")
    ) {
      window.location.href = "/login";
    }

    // Update the ref with the current error for next comparison
    prevErrorRef.current = getCarerVisitError;
  }, [getCarerVisitError]);


  return (
  <React.Fragment>
    <Helmet>
      <meta name="description" content="OSCAR" />
      <title>Excel Healthcare Services - Social and Domiciliary care</title>
    </Helmet>
    <main>
      <div>
        <Breadcrumb>
          <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
          <BreadcrumbItem active>Dashboard</BreadcrumbItem>
        </Breadcrumb>
      </div>
    </main>
    <div className="container">
      <div>
        <div>
          {error && !getCarerVisitLoader && (
            <Alert color={!error ? 'success' : 'danger'}>
              {message}
            </Alert>
          )}
          <div className="row" style={{marginBottom: "30px", paddingLeft: "15px"}}>
            <Typography variant="h5" style={{fontWeight: 'bold'}}>
              Activities
            </Typography>
          </div>
          <div className="row" style={{marginBottom: "20px", paddingLeft: "15px"}}>
            <FormControl
              variant="outlined"
              style={{minWidth: 200, margin: "10px 0"}}
            >
              <InputLabel id="demo-customized-select-label">Select Date</InputLabel>
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                value={filter}
                onChange={handleFilterChange}
                label="Select Date" // Required for outlined variant to display label properly
                style={{borderRadius: "4px"}}
              >
                <MenuItem value={"today"}>
                  <em>
                    Today
                  </em>
                </MenuItem>
                <MenuItem value={"all"}>
                  All
                </MenuItem>
                <MenuItem value={"yesterday"}>Yesterday</MenuItem>
                <MenuItem value={"tomorrow"}>Tomorrow</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div style={{paddingTop: "30px", paddingBottom: "150px"}}>
            {getCarerVisitLoader ? (
              <div style={{paddingLeft: "15px"}}>
                <p>Loading schedule...</p>
              </div>
            ) : Array.isArray(getCarerVisitSuccess) && getCarerVisitSuccess.length > 0 ? (
              <div className="row">
                {getCarerVisitSuccess.map((data) => (
                  <VisitsComponent
                    key={data.id}
                    data={data}
                    onClick={() => handleVisitClick(data)}
                  />
                ))}
              </div>
            ) : (
              getCarerVisitSuccess && getCarerVisitSuccess.length === 0 ?
                <p style={{paddingLeft: "15px"}}>No visits assigned.</p> : null
            )}
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>

  );
}

export default withRouter(CarerDashboard);